<template>
    <nav class="flex-1 bg-charcoal-800">
        <ul class="list-none">
            <template v-for="(item, index) in sections">
                <li v-bind:key="index"
                    v-if="checkAccess(item)"
                    class="relative group">
                    <a href="javascript:void(0)"
                        class="sidebar-menu-item pl-2 pr-20 py-3 group hover:text-white hover:bg-charcoal-700 focus:outline-none font-light"
                        :class="{'active': containsCurrentRoute(item) }"
                        v-if="item.children && item.children.length > 0">
                        <div class="inline-block w-10 text-center">
                            <font-awesome-icon :icon="['fal', item.icon]" class="text-lg mr-3" />
                        </div>
                        {{ item.title }}
                        <font-awesome-icon class="group-hover:hidden text-xl absolute right-0 mr-4"
                            :icon="['fal', 'angle-down']"
                            v-show="item.children && item.children.length > 0"
                        />
                        <font-awesome-icon class="hidden group-hover:inline-block text-xl absolute right-0 mr-4"
                            :icon="['fal', 'angle-right']"
                            v-show="item.children && item.children.length > 0" />
                    </a>
                    <a v-if="item.children && item.children.length === 0 && opensInNewTab(item)"
                        :href="item.route"
                        target="_blank"
                        rel="noopener"
                        class="sidebar-menu-item pl-2 py-3 group hover:text-white hover:bg-charcoal-700 focus:outline-none font-light flex flex-row">
                        <div class="inline-block w-10 text-center">
                            <font-awesome-icon :icon="['fal', item.icon]" class="text-lg mr-3" />
                        </div>
                        <span class="flex-grow">{{ item.title }}</span>
                    </a>
                    <router-link :to="{ path: item.route}"
                        class="sidebar-menu-item pl-2 py-3 group hover:text-white hover:bg-charcoal-700 focus:outline-none font-light flex flex-row"
                        :class="{'active': containsCurrentRoute(item) }"
                        v-else-if="item.children && item.children.length === 0">
                        <div class="inline-block w-10 text-center">
                            <font-awesome-icon :icon="['fal', item.icon]" class="text-lg mr-3" />
                        </div>
                        <span class="flex-grow">{{ item.title }}</span>
                        <font-awesome-icon class="text-l text-sidebar-icon float-right mr-2 group-hover:hidden"
                            :icon="['fal', 'angle-down']"
                            v-show="item.children && item.children.length > 0" />
                        <font-awesome-icon class="text-l text-sidebar-icon float-right mr-2 hidden group-hover:inline-block"
                            :icon="['fal', 'angle-right']"
                            v-show="item.children && item.children.length > 0" />
                    </router-link>
                    <ul class="hidden absolute list-none group-hover:block bg-charcoal-600 mt-px z-10"
                        :class="[item.subClasses, index > 8 ? 'bottom-0' : 'top-0']" v-if="item.children && item.children.length > 0" style="left: 15rem;">
                        <li v-for="(child, childIndex) in item.children.filter((child) => checkAccess(child))"
                            v-bind:key="childIndex"
                            class="sidebar-menu-item hover:text-white hover:bg-charcoal-700 focus:outline-none cursor-pointer w-56 font-light"
                            :class="{'sidebar-active-menu-item': isCurrentRoute(child.route) }">
                            <router-link :to="{ path: child.route}"
                                class="w-full" >
                                <div class="inline-block w-8 text-center">
                                    <font-awesome-icon :icon="['fal', child.icon]" class="mr-3" />
                                </div>
                                {{ child.title }}
                            </router-link>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
    export default {
        data: function () {
            return {}
        },

        methods: {
            children(item){
                return this.sections.filter(section => {
                    return section.parent_id === item.id;
                })
            },
            containsCurrentRoute(item) {
                if (!item.children || item.children.length === 0){
                    return this.isCurrentRoute(item.route);
                }

                if (item.children && item.children.length > 0){
                    const parts = this.$route.path.split('/');
                    const routes = item.children.filter((child) => child.route === this.$route.path || child.route === '/'+parts[1]+'/'+parts[2] || child.route === '/'+parts[1] );

                    if (routes.length > 0){
                        return true;
                    }
                }

                return false;
            },
            opensInNewTab(item) {
                return item.route === '/qr-scan';
            },
            isCurrentRoute(route) {
                const parts = this.$route.path.split('/');
                return this.$route.path === route || '/' + parts[1] + '/' + parts[2] === route || '/' + parts[1] + '/' + parts[2] + '/' + parts[3] === route || '/' + parts[1] === route;

            },
            checkAccess(item){
                // let access = false;
                //
                // if (item.guard === false){
                //     access = true;
                // }
                //
                // if (item.children && item.children.length > 0){
                //     if (item.route){
                //         // Check against User Object
                //         if (this.$store.getters.sections.indexOf(item.route) !== -1){
                //             access = true;
                //         }
                //     } else {
                //         // Check Children
                //         const found = item.children.filter((child) => child.route && this.$store.getters.sections.indexOf(child.route) !== -1);
                //
                //         if (found.length > 0){
                //             access = true;
                //         }
                //     }
                // } else {
                //     if (item.route){
                //         // Check against User Object
                //         if (this.$store.getters.sections.indexOf(item.route) !== -1){
                //             access = true;
                //         }
                //     }
                // }
                //
                // return access;
                return true;
            }
        },

        computed: {
            permissions () {
                return this.$store.getters.permissions;
            },
            sections (){
                return this.$store.getters.menu;
            }
        }
    }
</script>
